// extracted by mini-css-extract-plugin
export default {"root":"mobile-preview-shell_root__HknxG","host":"mobile-preview-shell_host__erS9y","stage":"mobile-preview-shell_stage__TRgx0","viewport":"mobile-preview-shell_viewport__8oOe+"};